import { useSelector } from 'react-redux';

import type { StoreError } from '../interfaces/error';
import { selectListingError } from '../selectors/listingError';

export const useListingError = (): StoreError | undefined =>
  useSelector(selectListingError);
